var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _c(
        "v-footer",
        { staticClass: "footer", attrs: { padless: "", fixed: "" } },
        [
          _c("v-container", { staticClass: "pt-0 pb-0" }, [
            _c(
              "div",
              { staticClass: "footer__menu" },
              [
                _c(
                  "v-row",
                  { staticClass: "footer__row pt-0 pb-0" },
                  _vm._l(_vm.links, function (link, index) {
                    return _c(
                      "v-col",
                      {
                        key: index,
                        staticClass: "footer__col",
                        attrs: { cols: "3" },
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "footer__link white--text",
                            attrs: { to: link.src, href: link.src },
                          },
                          [
                            _c("img", {
                              staticClass: "d-block text-center ma-auto",
                              attrs: { src: link.icon, alt: "", srcset: "" },
                            }),
                            _c("span", { staticClass: "footer__title" }, [
                              _vm._v(_vm._s(link.name)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _c("img", {
        attrs: {
          src: require("../assets/vgp-logo-simple.png"),
          alt: "",
          srcset: "",
        },
      }),
      _c("div", { staticClass: "copyright__content" }, [
        _vm._v(" Công ty CP VGP phân phối độc quyền tại Việt Nam. "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }